/**
* DevExpress Dashboard (_grid-item-viewer-adapter.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import * as ko from 'knockout';
import { DataItemViewerAdapter } from './_data-item-viewer-adapter';
export class GridItemViewerAdapter extends DataItemViewerAdapter {
    attachToModel(viewerItem, dataDashboardItem) {
        super.attachToModel(viewerItem, dataDashboardItem);
        viewerItem.clientStateUpdate.add(dataDashboardItem._processItemClientStateUpdate);
        viewerItem.clientFilterChanged.add(dataDashboardItem._processClientFilterChanged);
        viewerItem.clientFilterStateChanged.add(dataDashboardItem._processClientFilterStateChanged);
        viewerItem.gridWidthOptionsChanged = (state) => {
            if (this.context.isDesignMode()) {
                dataDashboardItem._setColumnWidthOptions(state);
            }
        };
        this.toDispose(ko.computed(() => {
            var gridItemViewer = viewerItem;
            gridItemViewer.resetClientStateOnUpdate = this.context.isDesignMode();
            gridItemViewer.manualyResetClientState = !this.context.isDesignMode();
        }));
    }
    detachFromModel(viewerItem, dataDashboardItem) {
        super.detachFromModel(viewerItem, dataDashboardItem);
        viewerItem.gridWidthOptionsChanged = null;
        viewerItem.clientStateUpdate.remove(dataDashboardItem._processItemClientStateUpdate);
    }
}
